import { ROOM_OBJECT_TYPE } from "./room-config";

const GLOBAL_ROOM_OBJECT_ENABLED_CONFIG = {
  [ROOM_OBJECT_TYPE.Chair]: true,
  [ROOM_OBJECT_TYPE.Table]: true,
  [ROOM_OBJECT_TYPE.Monitor]: true,
  [ROOM_OBJECT_TYPE.Keyboard]: true,
  [ROOM_OBJECT_TYPE.Mouse]: true,
}

export { GLOBAL_ROOM_OBJECT_ENABLED_CONFIG };
